export interface ChapterPage { page: number; label: string; kind: 'content' | 'chapter_title' }
export function initialChapterPage(pages: ChapterPage[], requested: number, explicitTitle: boolean): number | undefined {
  const current = pages.find(item => item.page === requested);
  if (current && (current.kind === 'content' || explicitTitle)) return current.page;
  return pages.find(item => item.kind === 'content')?.page ?? pages[0]?.page;
}
export function chapterPageHref(bookId: string, chapterId: string, item: ChapterPage): string {
  const query = new URLSearchParams({ chapter: chapterId });
  if (item.kind === 'chapter_title') query.set('cover', '1');
  return `/source-page/${encodeURIComponent(bookId)}/${item.page}?${query}`;
}
